

const escapeRegex = (s:string) => s.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");

export const matchWildcard = (str:string, rule:string) => {
	return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$").test(str);
}